/**
 * Service de calcul des prix 
 */
class PricingService {
    constructor() {

    }

    /**
     * Calcule le prix total des courses sélectionnées
     * 
     * @param {Object} list_courses - La liste des courses (objet List_Courses)
     * @param {Object} list_packs_courses - La liste des packs de courses
     * @param {Object} coureur - Les informations du coureur
     * @param {Object} vip_ins - Les informations VIP (optionnel)
     * @param {Object} inscription - L'inscription complète (optionnel)
     * @param {Object} groupe - Les informations du groupe (optionnel)
     * @returns {Promise<Object>} Le panier avec { prix, nb_articles }
     */
    async computeCoursesPrice(list_courses, list_packs_courses, coureur, vip_ins = null, inscription = null, groupe = null) {
        // Vérifier que list_courses existe et a une propriété list
        if (!list_courses || !list_courses.list || !Array.isArray(list_courses.list)) {
            return { prix: 0, nb_articles: 0 };
        }

        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };

        // Itérer sur toutes les courses
        for (let i = 0; i < list_courses.list.length; i++) {
            const course = list_courses.list[i];

            // Calculer le panier pour chaque course
            const item_cart = course.update_cart(
                list_courses.list,
                list_packs_courses,
                coureur,
                vip_ins,
                inscription,
                groupe
            );

            // Agrégation des résultats
            cart.nb_articles += parseInt(item_cart.nb_articles || 0);
            cart.prix += parseFloat(item_cart.prix || 0);
            cart.prix_regulier += parseFloat(item_cart.prix_regulier || item_cart.prix || 0);
        }

        // Arrondir le prix à 2 décimales
        cart.prix = parseFloat(cart.prix.toFixed(2));

        return cart;
    }

    computePackCoursesPrice(list_packs_courses, groupe = null) {
        if (!list_packs_courses || !list_packs_courses.list || !Array.isArray(list_packs_courses.list)) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
        for (let i = 0; i < list_packs_courses.list.length; i++) {
            const pack = list_packs_courses.list[i];
            const item_cart = pack.update_cart(groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles || 0);
            cart.prix += parseFloat(item_cart.prix || 0);
            cart.prix_regulier += parseFloat(item_cart.prix_regulier || item_cart.prix || 0);
        }
        cart.prix = parseFloat(cart.prix.toFixed(2));
        cart.prix_regulier = parseFloat(cart.prix_regulier.toFixed(2));
        return cart;
    }

    computeOptionsPrice(list_options, vip_ins = null, lien_groupe = null) {

        if (!list_options || !list_options.list || !Array.isArray(list_options.list)) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
        for (let i = 0; i < list_options.list.length; i++) {
            const option = list_options.list[i];
            const item_cart = option.update_cart(vip_ins, lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles || 0);
            cart.prix += parseFloat(item_cart.prix || 0);
            cart.prix_regulier += parseFloat(item_cart.prix_regulier || item_cart.prix || 0);
        }
        cart.prix = parseFloat(cart.prix.toFixed(2));
        cart.prix_regulier = parseFloat(cart.prix_regulier.toFixed(2));
        return cart;
    }

    computeActivitesPrice(list_activites, vip_ins = null, lien_groupe = null) {
        if (!list_activites || !list_activites.list || !Array.isArray(list_activites.list)) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
        for (let i = 0; i < list_activites.list.length; i++) {
            const activite = list_activites.list[i];
            const item_cart = activite.update_cart(vip_ins, lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles || 0);
            cart.prix += parseFloat(item_cart.prix || 0);
            cart.prix_regulier += parseFloat(item_cart.prix_regulier || item_cart.prix || 0);
        }
        cart.prix = parseFloat(cart.prix.toFixed(2));
        cart.prix_regulier = parseFloat(cart.prix_regulier.toFixed(2));
        return cart;
    }


    computeArticlesPrice(list_articles, lien_groupe = null) {
        if (!list_articles || !list_articles.list || !Array.isArray(list_articles.list)) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0 };
        for (let i = 0; i < list_articles.list.length; i++) {
            const article = list_articles.list[i];
            const item_cart = article.update_cart(lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles || 0);
            cart.prix += parseFloat(item_cart.prix || 0);
        }
        cart.prix = parseFloat(cart.prix.toFixed(2));
        return cart;
    }

    computeGIAPrice(gia) {
        if (!gia) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0 };
        const item_cart = gia.update_cart();
        cart.nb_articles += parseInt(item_cart.nb_articles || 0);
        cart.prix += parseFloat(item_cart.prix || 0);
        cart.prix = parseFloat(cart.prix.toFixed(2));
        return cart;
    }

    computeDonationPrice(donation) {
        if (!donation) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0 };
        const item_cart = donation.update_cart();
        cart.nb_articles += parseInt(item_cart.nb_articles || 0);
        cart.prix += parseFloat(item_cart.prix || 0);
        cart.prix = parseFloat(cart.prix.toFixed(2));
        return cart;
    }
    computeAlerteSMSPrice(alerte_sms) {
        if (!alerte_sms) {
            return { prix: 0, nb_articles: 0 };
        }
        let cart = { nb_articles: 0, prix: 0 };
        const item_cart = alerte_sms.update_cart();
        cart.nb_articles += parseInt(item_cart.nb_articles || 0);
        cart.prix += parseFloat(item_cart.prix || 0);
        cart.prix = parseFloat(cart.prix.toFixed(2));
        return cart;
    }
}
export default new PricingService();